<!-- Arama sırasında loading -->
<app-loading *ngIf="isSearching" [size]="'large'" [fullScreen]="true" [message]="'Yeni tarihler aranıyor...'"></app-loading>

<div *ngIf="hotelWithPeriods$ | async as data; else loading" [hidden]="isSearching">
  <div *ngIf="data.details && data.details.hotel as hotel">
    <main>

      <div class="singleMenu js-singleMenu">
        <div class="col-12">
          <div class="singleMenu__content">
            <div class="container">
              <div class="row y-gap-20 justify-between items-center">
                <div class="col-auto">
                  <div class="singleMenu__links row x-gap-30 y-gap-10">
                    <div class="col-auto">
                      <a href="#overview">Overview</a>
                    </div>
                    <div class="col-auto">
                      <a href="#rooms">Rooms</a>
                    </div>
                    <div class="col-auto">
                      <a href="#reviews">Reviews</a>
                    </div>
                    <div class="col-auto">
                      <a href="#facilities">Facilities</a>
                    </div>
                    <div class="col-auto">
                      <a href="#faq">Faq</a>
                    </div>
                  </div>
                </div>

                <div class="col-auto">
                  <div class="row x-gap-15 y-gap-15 items-center">
                    <div class="col-auto">
                      <div class="text-14 lh-14 text-light-1">
                        Temel fiyat
                        <span class="text-22 text-dark-1 fw-500">
                          {{ data.pricingDetails?.basePrice?.value | currency : "TRY" : "symbol" : "1.0-0" }}
                        </span>
                      </div>
                    </div>

                    <div class="col-auto">
                      <a href="#" class="button -md -dark-1 bg-blue-1 text-white">
                        View Details
                        <div class="icon-arrow-top-right ml-15"></div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

 

      <section class="pt-40">
        <div class="container">
          <div class="hotelSingleGrid">
            <div>
              <!-- Desktop Gallery - Mobilde gizli -->
              <div class="galleryGrid -type-2 d-none d-md-grid" *ngIf="hotel.images?.length">
                <div class="galleryGrid__item relative d-flex justify-end" *ngIf="hotel.images[0]"
                  (click)="openGalleryModal(0)" style="cursor: pointer;">
                  <img [src]="hotel.images[0].url" alt="image" class="rounded-4" />
                </div>

                <div class="galleryGrid__item" *ngIf="hotel.images[1]" (click)="openGalleryModal(1)"
                  style="cursor: pointer;">
                  <img [src]="hotel.images[1].url" alt="image" class="rounded-4" />
                </div>

                <div class="galleryGrid__item" *ngIf="hotel.images[2]" (click)="openGalleryModal(2)"
                  style="cursor: pointer;">
                  <img [src]="hotel.images[2].url" alt="image" class="rounded-4" />
                </div>

                <div class="galleryGrid__item relative d-flex justify-end items-end" *ngIf="hotel.images.length > 3"
                  (click)="openGalleryModal(3)" style="cursor: pointer;">
                  <img [src]="hotel.images[3].url" alt="image" class="rounded-4" />

                  <div class="absolute px-10 py-10">
                    <button class="button -blue-1 px-24 py-15 bg-white text-dark-1">
                      Tümünü Gör {{ hotel.images.length }}
                    </button>
                  </div>
                </div>
              </div>

              <!-- Mobile Gallery Slider - Sadece mobilde görünür -->
              <div class="mobile-gallery-slider d-md-none" *ngIf="hotel.images?.length">
                <div class="mobile-gallery-container"
                     (click)="openGalleryModal(currentImageIndex)"
                     (touchstart)="onGalleryTouchStart($event, hotel.images)"
                     (touchend)="onGalleryTouchEnd($event)">
                  <img [src]="hotel.images[currentImageIndex].url" alt="image" class="mobile-gallery-image rounded-4" />

                  <!-- Rating pill (sağ üst) -->
                  <div class="mobile-gallery-rating" *ngIf="hotel.reviewResult?.rating">
                    <strong>{{ hotel.reviewResult.rating }}</strong>
                    <span *ngIf="hotel.reviewResult.ratingText">{{ hotel.reviewResult.ratingText }}</span>
                  </div>

                  <!-- Dot göstergesi (sol alt) -->
                  <div class="mobile-gallery-dots" *ngIf="hotel.images.length > 1">
                    <span class="mobile-gallery-dot"
                          *ngFor="let img of hotel.images.slice(0, 5); let i = index"
                          [class.active]="currentImageIndex === i"></span>
                  </div>

                  <!-- Sayaç (sağ alt) -->
                  <div class="mobile-gallery-counter" *ngIf="hotel.images.length > 1">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                    {{ currentImageIndex + 1 }}/{{ hotel.images.length }}
                  </div>
                </div>

                <!-- Brand + Paylaş bar -->
                <div class="mobile-gallery-actions">
                  <div class="mobile-gallery-brand">
                    <img src="assets/maximum@2x.png" alt="Maximum" class="mobile-gallery-brand__logo" />
                    <span class="mobile-gallery-brand__text">'a özel fırsatları kaçırma!</span>
                  </div>
                  <button type="button" class="mobile-gallery-share" (click)="onShareHotel(hotel)" aria-label="Paylaş">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg>
                  </button>
                </div>
              </div>

              <!-- Mobile Hotel Hero - Sadece mobilde -->
              <div class="mobile-hotel-hero d-md-none">
                <h1 class="mobile-hotel-hero__name">{{ hotel.name }}</h1>
                <button type="button"
                        class="mobile-hotel-hero__location"
                        (click)="openKonumModal(data.mapUrl, hotel.nearDistances, hotel)">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                  <span>{{ getHotelAddress(data.details.hotel) }}</span>
                </button>
              </div>

              <!-- Gallery Modal -->
              <div *ngIf="isGalleryModalOpen && hotel.images?.length" class="gallery-modal-overlay"
                (click)="closeGalleryModal()">
                <div class="gallery-modal-content slider" (click)="$event.stopPropagation()">
                  <button (click)="closeGalleryModal()" class="gallery-modal-close-button">✕</button>
                  <button class="slider-button prev" (click)="prevImage(hotel.images)">‹</button>
                  <img [src]="hotel.images[currentImageIndex].url" alt="image">
                  <button class="slider-button next" (click)="nextImage(hotel.images)">›</button>
                </div>
              </div>

              <!-- Room Gallery Modal -->
              <div *ngIf="isRoomGalleryModalOpen && currentRoomImages.length" class="gallery-modal-overlay"
                (click)="closeRoomGalleryModal()">
                <div class="gallery-modal-content slider" (click)="$event.stopPropagation()">
                  <button (click)="closeRoomGalleryModal()" class="gallery-modal-close-button">✕</button>
                  <button class="slider-button prev" (click)="prevRoomImage()" *ngIf="currentRoomImages.length > 1">‹</button>
                  <img [src]="currentRoomImages[currentRoomImageIndex].url" alt="Oda Görseli">
                  <button class="slider-button next" (click)="nextRoomImage()" *ngIf="currentRoomImages.length > 1">›</button>
                  <!-- Görsel sayacı -->
                  <div class="gallery-counter" style="position: absolute; bottom: 20px; left: 50%; transform: translateX(-50%); background: rgba(0,0,0,0.7); color: white; padding: 8px 16px; border-radius: 20px; font-size: 14px;">
                    {{ currentRoomImageIndex + 1 }} / {{ currentRoomImages.length }}
                  </div>
                </div>
              </div>

              <div class="row justify-between items-end pt-40">
                <div class="col-auto">
                  <div class="row x-gap-20 y-gap-20 items-center">
                    <div class="col-auto d-none d-md-block">
                      <h1 class="text-30 sm:text-25 fw-600">
                        {{ hotel.name }}
                      </h1>
                      <button type="button"
                              *ngIf="getHotelAddress(data.details.hotel)"
                              class="hotel-location-btn"
                              (click)="openKonumModal(data.mapUrl, hotel.nearDistances, hotel)">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                        <span>{{ getHotelAddress(data.details.hotel) }}</span>
                      </button>
                    </div>
                  </div>

                  <!-- Giriş/Çıkış Saatleri (sadece desktop) -->
                  <div class="row x-gap-20 y-gap-10 items-center pt-10 d-none d-md-flex" *ngIf="hotel.checkIn || hotel.checkOut">
                    <div class="col-auto" *ngIf="hotel.checkIn">
                      <span class="text-14 text-light-1">
                        <i class="icon-clock text-12 mr-5"></i>Giriş: {{ hotel.checkIn }}
                      </span>
                    </div>
                    <div class="col-auto" *ngIf="hotel.checkOut">
                      <span class="text-14 text-light-1">
                        <i class="icon-clock text-12 mr-5"></i>Çıkış: {{ hotel.checkOut }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>


              <div id="overview" class="row y-gap-40 pt-40">

                <div class="col-12" *ngIf="hotel.facilityDetails?.length">
                  <h3 class="text-22 fw-500 pt-40 border-top-light">
                    Otel Özellikleri
                  </h3>
                  <div class="hotel-facility-chips">
                    <span class="hotel-facility-chip" *ngFor="let f of hotel.facilityDetails.slice(0, 4)">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3554d1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="9 12 11 14 15 10"/></svg>
                      {{ f.name }}
                    </span>
                  </div>
                  <a class="hotel-facilities-link"
                     (click)="openHotelFacilitiesSheet(hotel.facilityDetails)"
                     *ngIf="hotel.facilityDetails.length > 4">
                    Bu Tesisin Tüm Özelliklerini Gör
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
                  </a>
                </div>
              </div>
            </div>

            <div>
              <div class="px-30 py-30 border-light rounded-4 hide-on-mobile">
                <!-- Inline Harita -->
                <div class="inline-map-container" *ngIf="data.mapUrl">
                  <iframe 
                    [src]="data.mapUrl" 
                    allowfullscreen="" 
                    loading="lazy" 
                    referrerpolicy="no-referrer-when-downgrade">
                  </iframe>
                </div>
                <div class="inline-map-placeholder" *ngIf="!data.mapUrl">
                  <i class="icon-location text-30 text-light-1"></i>
                  <span class="text-14 text-light-1 mt-10">Harita bilgisi bulunamadı</span>
                </div>

                <div class="border-top-light mt-15 mb-15"></div>

                <div *ngIf="hotel.nearDistances as nearDistances">
                  <div class="text-15 fw-500">{{ hotel.name }} Nerede?</div>
                  <div *ngFor="let item of nearDistances" class="d-flex justify-between pt-10">
                    <i class="icon-pedestrian text-20 text-blue-1"></i>
                    <div class="text-14">{{ item.name }}</div>
                    <div class="text-14 text-light-1">
                      {{ item.distance }} {{ item.unitTypeText }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- ==================================================
                   Meal Types Section (Formerly Property Highlights)
               ================================================== -->
              <div class="px-30 py-30 border-light rounded-4 mt-30 hide-on-mobile" *ngIf="data.details.hotel.mealTypeInfos?.length">
                <div class="text-18 fw-500">Yemek Seçenekleri</div>

                <div *ngFor="let mealInfo of getUniqueMealTypes(data.details.hotel.mealTypeInfos)">
                  <div class="row x-gap-20 y-gap-20 pt-20">
                    <div class="col-auto">
                      <i class="icon-food text-24 text-blue-1"></i>
                    </div>
                    <div class="col-auto">
                      <div class="text-15">{{ mealInfo.mealTypeText }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="rooms" class="pt-30">
        <div class="container">
          <div class="row pb-20 items-center justify-between">
            <div class="col-auto">
              <h3 class="text-22 fw-500">Odalar</h3>
            </div>
          </div>

          <!-- Mobil tarih/misafir değiştirme barı -->
          <div class="m-date-bar d-md-none" *ngIf="isMobileView" (click)="openDatePicker()">
            <div class="m-date-bar__dates">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              <span *ngIf="minNightCheckInDate && minNightCheckOutDate">
                {{ minNightCheckInDate | date:'dd MMM':'':'tr' }} - {{ minNightCheckOutDate | date:'dd MMM':'':'tr' }}
                <strong>({{ getNightCount() }} Gece)</strong>
              </span>
              <span *ngIf="!minNightCheckInDate || !minNightCheckOutDate" style="color: #3554d1;">Tarih Seçin</span>
            </div>
            <span class="m-date-bar__change">Değiştir</span>
          </div>

          <!-- Mobil Compact Search Bar (sub-navbar tarafından değiştirildi, gizli) -->
          <div class="mobile-search-compact mb-15" style="display:none" (click)="isMobileSearchExpanded = !isMobileSearchExpanded">
            <div class="d-flex items-center justify-between">
              <div class="d-flex items-center" style="gap: 12px; overflow: hidden;">
                <i class="icon-search text-16 text-blue-1" style="flex-shrink: 0;"></i>
                <div class="d-flex items-center text-13 fw-500 text-dark-1" style="gap: 6px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                  <span *ngIf="minNightCheckInDate && minNightCheckOutDate">
                    {{ minNightCheckInDate | date:'dd MMM':'':'tr' }} → {{ minNightCheckOutDate | date:'dd MMM':'':'tr' }}
                  </span>
                  <span *ngIf="!minNightCheckInDate || !minNightCheckOutDate" style="color: #3554d1;">Tarih Seçin</span>
                  <span class="text-light-1">·</span>
                  <span>{{ roomCount }} Oda, {{ adultCount }} Yet.<span *ngIf="childCount > 0">, {{ childCount }} Çoc.</span></span>
                </div>
              </div>
              <i class="icon-chevron-down text-12 text-light-1 transition-transform" [class.rotate-180]="isMobileSearchExpanded" style="flex-shrink: 0; margin-left: 8px;"></i>
            </div>
          </div>

          <!-- Tarih ve Kişi Seçim Bar'ı -->
          <div #dateSelectionBar id="dateSelectionBar" class="date-selection-bar bg-white border-light rounded-8 px-20 py-15 mb-30"
               [class.mobile-search-hidden]="!isMobileSearchExpanded">
            <div class="row items-center y-gap-15">
              <!-- Giriş/Çıkış Tarihi - Dropdown -->
              <div class="col-lg-5 col-md-6 col-12">
                <div class="calendar-container" style="position: relative;">
                  <div class="detail-date-bar" (click)="toggleMinNightCalendar(); $event.stopPropagation()">
                    <i class="icon-calendar text-18 mr-10" [style.color]="minNightCheckInDate ? '#3554d1' : '#f59e0b'"></i>
                    <div *ngIf="minNightCheckInDate && minNightCheckOutDate" class="d-flex items-center">
                      <span class="text-14 fw-500 text-dark-1">{{ minNightCheckInDate | date:'dd MMM':'':'tr' }}</span>
                      <span class="text-14 text-light-1 mx-10">→</span>
                      <span class="text-14 fw-500 text-dark-1">{{ minNightCheckOutDate | date:'dd MMM':'':'tr' }}</span>
                    </div>
                    <span *ngIf="!minNightCheckInDate || !minNightCheckOutDate" class="text-14 fw-500" style="color: #f59e0b;">Tarih Seçin</span>
                    <i class="icon-chevron-down text-12 text-light-1 ml-auto"></i>
                  </div>
                  
                  <!-- Dropdown Takvim -->
                  <div *ngIf="isMinNightCalendarOpen" (click)="$event.stopPropagation()" style="position: absolute; top: 100%; left: 0; margin-top: 4px; z-index: 1000; background: #fff; border: 1px solid #e5e7eb; border-radius: 8px; padding: 12px; box-shadow: 0 4px 16px rgba(0,0,0,0.2); width: 260px;">
                    <div *ngIf="hasMinNightRestriction" style="font-size: 11px; color: #f59e0b; margin-bottom: 8px; padding: 4px 8px; background: #fffbeb; border-radius: 4px; text-align: center;">
                      ⚠️ Min {{ minNightCount }} gece seçin
                    </div>
                    <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px;">
                      <button type="button" (click)="prevCalendarMonth()" style="width: 26px; height: 26px; background: #f3f4f6; color: #6b7280; border: none; border-radius: 4px; cursor: pointer; font-size: 14px;">‹</button>
                      <span style="font-size: 13px; font-weight: 600; color: #111;">{{ getCalendarMonthYear() }}</span>
                      <button type="button" (click)="nextCalendarMonth()" style="width: 26px; height: 26px; background: #f3f4f6; color: #6b7280; border: none; border-radius: 4px; cursor: pointer; font-size: 14px;">›</button>
                    </div>
                    <div style="display: grid; grid-template-columns: repeat(7, 1fr); margin-bottom: 4px;">
                      <span *ngFor="let d of ['Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct', 'Pz']" style="text-align: center; font-size: 10px; font-weight: 500; color: #9ca3af; padding: 2px 0;">{{ d }}</span>
                    </div>
                    <div style="display: grid; grid-template-columns: repeat(7, 1fr); gap: 2px;">
                      <button *ngFor="let day of inlineCalendarDays" type="button" [disabled]="day.isPast || !day.isCurrentMonth" (click)="onInlineCalendarDayClick(day)"
                        [style.background]="day.isSelected ? '#3554d1' : (day.isInRange ? '#e8f0fe' : 'transparent')"
                        [style.color]="day.isSelected ? '#fff' : (day.isPast || !day.isCurrentMonth ? '#d1d5db' : '#374151')"
                        [style.fontWeight]="day.isSelected ? '600' : '400'"
                        style="width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; font-size: 12px; border: none; border-radius: 4px; cursor: pointer;">{{ day.dayNumber }}</button>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Oda ve Kişi Sayısı - Dropdown -->
              <div class="col-lg-4 col-md-6 col-12">
                <div class="guest-selector-container" style="position: relative;">
                  <div class="d-flex items-center" (click)="toggleGuestSelector(); $event.stopPropagation()" style="cursor: pointer; padding: 8px 12px; border: 1px solid #e5e7eb; border-radius: 8px; background: #f9fafb;">
                    <i class="icon-bed text-18 text-blue-1 mr-10"></i>
                    <span class="text-14 fw-500 text-dark-1">{{ roomCount }} Oda, {{ adultCount }} Yetişkin<span *ngIf="childCount > 0">, {{ childCount }} Çocuk</span></span>
                    <i class="icon-chevron-down text-12 text-light-1 ml-auto"></i>
                  </div>
                  
                  <!-- Misafir Seçici Dropdown -->
                  <div *ngIf="isGuestSelectorOpen" (click)="$event.stopPropagation()" style="position: absolute; top: 100%; left: 0; margin-top: 4px; z-index: 1000; background: #fff; border: 1px solid #e5e7eb; border-radius: 8px; padding: 16px; box-shadow: 0 4px 16px rgba(0,0,0,0.15); width: 280px;">
                    
                    <!-- Yetişkin -->
                    <div class="d-flex items-center justify-between mb-15">
                      <div>
                        <div class="text-14 fw-500">Yetişkin</div>
                      </div>
                      <div class="d-flex items-center">
                        <button type="button" class="d-flex items-center justify-center" 
                          (click)="updateGuestCount('adults', false)"
                          [disabled]="adultCount <= 1"
                          style="width: 32px; height: 32px; border: 1px solid #e5e7eb; border-radius: 50%; background: #fff; cursor: pointer;">
                          <span style="font-size: 16px; color: #3554d1;">−</span>
                        </button>
                        <span class="text-14 fw-500 mx-15" style="min-width: 20px; text-align: center;">{{ adultCount }}</span>
                        <button type="button" class="d-flex items-center justify-center" 
                          (click)="updateGuestCount('adults', true)"
                          [disabled]="adultCount >= 10"
                          style="width: 32px; height: 32px; border: 1px solid #e5e7eb; border-radius: 50%; background: #fff; cursor: pointer;">
                          <span style="font-size: 16px; color: #3554d1;">+</span>
                        </button>
                      </div>
                    </div>
                    
                    <!-- Çocuk -->
                    <div class="d-flex items-center justify-between mb-15">
                      <div>
                        <div class="text-14 fw-500">Çocuk</div>
                        <div class="text-12 text-light-1">0-17 yaş</div>
                      </div>
                      <div class="d-flex items-center">
                        <button type="button" class="d-flex items-center justify-center" 
                          (click)="updateGuestCount('children', false)"
                          [disabled]="childCount <= 0"
                          style="width: 32px; height: 32px; border: 1px solid #e5e7eb; border-radius: 50%; background: #fff; cursor: pointer;">
                          <span style="font-size: 16px; color: #3554d1;">−</span>
                        </button>
                        <span class="text-14 fw-500 mx-15" style="min-width: 20px; text-align: center;">{{ childCount }}</span>
                        <button type="button" class="d-flex items-center justify-center" 
                          (click)="updateGuestCount('children', true)"
                          [disabled]="childCount >= 6"
                          style="width: 32px; height: 32px; border: 1px solid #e5e7eb; border-radius: 50%; background: #fff; cursor: pointer;">
                          <span style="font-size: 16px; color: #3554d1;">+</span>
                        </button>
                      </div>
                    </div>
                    
                    <!-- Çocuk Yaşları -->
                    <div *ngIf="childCount > 0" class="mb-15 pt-10" style="border-top: 1px solid #e5e7eb;">
                      <div class="text-13 fw-500 mb-10">Çocuk Yaşları</div>
                      <div class="d-flex flex-wrap" style="gap: 8px;">
                        <div *ngFor="let age of childrenAges; let i = index" style="flex: 0 0 calc(50% - 4px);">
                          <select [value]="childrenAges[i]" (change)="updateChildAge(i, +$any($event.target).value)"
                            style="width: 100%; padding: 6px 10px; border: 1px solid #e5e7eb; border-radius: 6px; font-size: 13px; background: #f9fafb;">
                            <option *ngFor="let a of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17]" [value]="a">{{ i + 1 }}. Çocuk: {{ a }} yaş</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Oda -->
                    <div class="d-flex items-center justify-between pt-10" style="border-top: 1px solid #e5e7eb;">
                      <div>
                        <div class="text-14 fw-500">Oda</div>
                      </div>
                      <div class="d-flex items-center">
                        <button type="button" class="d-flex items-center justify-center" 
                          (click)="updateGuestCount('rooms', false)"
                          [disabled]="roomCount <= 1"
                          style="width: 32px; height: 32px; border: 1px solid #e5e7eb; border-radius: 50%; background: #fff; cursor: pointer;">
                          <span style="font-size: 16px; color: #3554d1;">−</span>
                        </button>
                        <span class="text-14 fw-500 mx-15" style="min-width: 20px; text-align: center;">{{ roomCount }}</span>
                        <button type="button" class="d-flex items-center justify-center" 
                          (click)="updateGuestCount('rooms', true)"
                          [disabled]="roomCount >= 4"
                          style="width: 32px; height: 32px; border: 1px solid #e5e7eb; border-radius: 50%; background: #fff; cursor: pointer;">
                          <span style="font-size: 16px; color: #3554d1;">+</span>
                        </button>
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>
              
              <!-- Ara Butonu -->
              <div class="col-lg-3 col-md-12 col-12">
                <button class="button -md bg-blue-1 text-white w-100" (click)="searchWithCurrentDates()">
                  Ara
                </button>
              </div>
            </div>
          </div>

          <!-- Minimum Gece Uyarısı - Sadece kısıtlama varsa -->
          <div *ngIf="hasMinNightRestriction" class="mb-30">
            <!-- Alternatif Odalar Bilgisi -->
            <div *ngIf="alternativeRoomGroups.length > 0" class="bg-light-2 border-light rounded-8 px-30 py-20">
              <h5 class="text-16 fw-500 mb-15">
                <i class="icon-info mr-10 text-blue-1"></i>
                {{ minNightCount }} gece konaklamanız halinde bu odalar müsait olacaktır:
              </h5>
              <div class="row y-gap-10 x-gap-10">
                <div *ngFor="let alt of alternativeRoomGroups.slice(0, 6)" class="col-auto">
                  <span class="badge px-15 py-10 rounded-4 border-light" style="background-color: #fff;">
                    {{ alt.roomGroup?.rooms?.[0]?.mealType || 'Oda' }}
                  </span>
                </div>
                <div *ngIf="alternativeRoomGroups.length > 6" class="col-auto">
                  <span class="text-14 text-light-1">+{{ alternativeRoomGroups.length - 6 }} daha fazla</span>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="data.roomGroups.length === 0 && !hasMinNightRestriction && !isDatelessSearch" class="py-30 text-center">
            <div class="text-18 text-light-1">
              <i class="icon-info mr-10"></i>
              Bu otel için oda bilgisi bulunamadı.
            </div>
          </div>

          <!-- ====== TEK ODA MODU (roomCount === 1) ====== -->
          <ng-container *ngIf="roomCount <= 1">
            <div *ngFor="let roomGroup of data.roomGroups">
              <div *ngFor="let room of roomGroup.rooms" class="border-top-light pt-30 mt-30">
                <ng-container *ngTemplateOutlet="singleRoomCard; context: { $implicit: room, roomGroup: roomGroup }"></ng-container>
              </div>
            </div>
          </ng-container>

          <!-- ====== ÇOKLU ODA MODU (roomCount > 1) ====== -->
          <ng-container *ngIf="roomCount > 1">

            <!-- Her oda pozisyonu için ayrı bölüm -->
            <div *ngFor="let pos of roomPositions" class="room-position-section">
              <div class="room-position-header mt-40 mb-10">
                <h3 class="text-22 fw-600 text-dark-1">{{ pos + 1 }}. Oda</h3>
              </div>

              <div *ngFor="let room of getRoomsToShowForPosition(pos, data.roomGroups)"
                   class="border-top-light pt-30 mt-30 room-option-card rounded-8"
                   [class.room-option-selected]="isRoomSelectedForPosition(pos, room._identifier)">
                <div class="row x-gap-20 y-gap-20">
                  <div class="col-md-auto">
                    <div class="cardImage ratio ratio-1:1 w-250 md:w-1/1 rounded-4"
                      [class.cursor-pointer]="room.roomImages && room.roomImages.length > 0"
                      (click)="room.roomImages && room.roomImages.length > 0 && openRoomGalleryModal(room.roomImages, 0)">
                      <div class="cardImage__content">
                        <img *ngIf="room.roomImages && room.roomImages.length > 0"
                          class="rounded-4 col-12"
                          [src]="room.roomImages[0].url"
                          [alt]="room.roomTypeText || room.roomType || 'Oda'" />
                        <div *ngIf="!room.roomImages || room.roomImages.length === 0"
                          class="rounded-4 col-12 bg-light-2 d-flex items-center justify-center" style="height: 100%;">
                          <i class="icon-bed text-40 text-light-1"></i>
                        </div>
                      </div>
                      <div *ngIf="room.roomImages && room.roomImages.length > 1"
                        class="absolute px-10 py-10" style="bottom: 0; right: 0;">
                        <div class="button -blue-1 px-15 py-5 bg-white text-dark-1 text-12 rounded-4">
                          <i class="icon-image mr-5"></i>{{ room.roomImages.length }} Görsel
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md">
                    <h3 class="text-18 lh-16 fw-500">
                      {{ room.roomTypeText || room.roomType || 'Oda' }}
                    </h3>
                    <div class="row x-gap-10 y-gap-10 items-center pt-10">
                      <div class="col-auto">
                        <a class="text-14 text-blue-1 fw-500 cursor-pointer">
                          {{ room.mealType || 'Konaklama' }}
                          <i class="icon-chevron-right text-10 ml-5"></i>
                        </a>
                      </div>
                    </div>
                    <div class="row x-gap-10 y-gap-10 pt-15">
                      <div class="col-auto" *ngFor="let facility of getRoomFacilitiesToShow(room)">
                        <div class="border-light rounded-100 py-5 px-20 text-14 lh-14">
                          {{ facility.name }}
                        </div>
                      </div>
                    </div>
                    <div *ngIf="room.facilities && room.facilities.length > 6" class="mt-10">
                      <a (click)="toggleRoomFacilities(room.key || room.roomKey || room.hotelRoomCode)"
                        class="text-blue-1 fw-500 cursor-pointer text-14">
                        {{ showAllRoomFacilities[room.key || room.roomKey || room.hotelRoomCode] ? "Daha Az Göster" : "Tümünü Gör" }}
                      </a>
                    </div>
                  </div>

                  <div class="col-md-auto text-right md:text-left">
                    <div class="text-14 text-dark-1 fw-500" *ngIf="searchCheckInDate && searchCheckOutDate">
                      {{ searchCheckInDate | date:'dd.MM.yyyy' }} - {{ searchCheckOutDate | date:'dd.MM.yyyy' }}
                    </div>
                    <ng-container *ngIf="!isDatelessSearch">
                      <div *ngIf="room.discount && room.discount.value > 0" class="mt-5">
                        <div class="text-14 text-light-1" style="text-decoration: line-through;">
                          {{ (room.totalPrice.value + room.discount.value) | currency : "TRY" : "symbol" : "1.0-0" }}
                        </div>
                        <div class="text-22 lh-12 fw-600">
                          {{ room.totalPrice.value | currency : "TRY" : "symbol" : "1.0-0" }}
                        </div>
                        <div class="text-12 text-green-2 fw-500">
                          {{ room.discount.value | currency : "TRY" : "symbol" : "1.0-0" }} indirim
                        </div>
                        <app-installment-badge [price]="room.totalPrice.value" [maxInstallment]="maxInstallment" class="d-block mt-5"></app-installment-badge>
                      </div>
                      <div *ngIf="!room.discount || room.discount.value === 0" class="mt-5">
                        <div class="text-22 lh-12 fw-600">
                          <span *ngIf="room.totalPrice && room.totalPrice.value">
                            {{ room.totalPrice.value | currency : "TRY" : "symbol" : "1.0-0" }}
                          </span>
                          <span *ngIf="!room.totalPrice || !room.totalPrice.value" class="text-light-1 text-16">
                            Fiyat bilgisi yok
                          </span>
                        </div>
                        <div *ngIf="room.totalPrice && room.totalPrice.value" class="text-14 text-light-1">Oda Fiyatı</div>
                        <app-installment-badge *ngIf="room.totalPrice?.value" [price]="room.totalPrice.value" [maxInstallment]="maxInstallment" class="d-block mt-5"></app-installment-badge>
                      </div>
                    </ng-container>

                    <!-- Seç butonu -->
                    <div class="mt-20">
                      <button
                        *ngIf="!isRoomSelectedForPosition(pos, room._identifier)"
                        class="button -md -outline-blue-1 text-blue-1"
                        (click)="selectRoomForPosition(pos, room._identifier, data.roomGroups)" type="button">
                        <span class="d-flex items-center justify-center">
                          Seç
                          <i class="icon-check text-12 ml-10"></i>
                        </span>
                      </button>
                      <button
                        *ngIf="isRoomSelectedForPosition(pos, room._identifier)"
                        class="button -md -dark-1 bg-green-2 text-white"
                        (click)="selectRoomForPosition(pos, room._identifier, data.roomGroups)" type="button">
                        <span class="d-flex items-center justify-center">
                          Seçildi
                          <i class="icon-check text-12 ml-10"></i>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tümünü Gör -->
              <div *ngIf="getUniqueRoomsForPosition(pos, data.roomGroups).length > multiRoomInitialCount" class="mt-20 text-center">
                <a (click)="toggleShowAllRoomsForPosition(pos)" class="text-blue-1 fw-500 cursor-pointer text-14">
                  {{ showAllRoomsForPosition[pos] ? 'Daha Az Göster' : 'Tümünü Gör (' + getUniqueRoomsForPosition(pos, data.roomGroups).length + ' seçenek)' }}
                </a>
              </div>
            </div>

            <!-- Seçim Özeti & Rezervasyon Butonu -->
            <div *ngIf="matchedGroupIndex >= 0 && data.roomGroups[matchedGroupIndex]"
                 class="room-selection-summary border-light rounded-8 mt-30" style="overflow: hidden;">
              <div style="padding: 16px 20px; background: #f0fdf4; border-bottom: 1px solid #bbf7d0;">
                <span class="text-15 fw-600 text-dark-1">Seçiminiz</span>
              </div>
              <div style="padding: 16px 20px;">
                <div *ngFor="let room of data.roomGroups[matchedGroupIndex].rooms; let ri = index"
                     class="d-flex items-center justify-between"
                     [class.mt-10]="ri > 0"
                     [class.pt-10]="ri > 0"
                     [style.border-top]="ri > 0 ? '1px solid #f0f0f5' : 'none'">
                  <div class="d-flex items-center">
                    <span class="combo-room-badge mr-10">{{ ri + 1 }}. Oda</span>
                    <span class="text-14 text-dark-1">{{ room.roomTypeText || room.roomType || 'Oda' }}</span>
                    <span class="text-13 text-blue-1 ml-10">{{ room.mealType || '' }}</span>
                  </div>
                  <span *ngIf="room.totalPrice?.value" class="text-14 fw-600 text-dark-1">
                    {{ room.totalPrice.value | currency : 'TRY' : 'symbol' : '1.0-0' }}
                  </span>
                </div>
              </div>
              <div style="padding: 14px 20px; background: #f8fafc; border-top: 1px solid #e5e7eb;">
                <div class="d-flex items-center justify-between">
                  <div>
                    <div class="text-16 fw-600 text-dark-1">
                      Toplam: {{ getMatchedComboTotal(data.roomGroups) | currency : 'TRY' : 'symbol' : '1.0-0' }}
                    </div>
                    <div *ngIf="searchCheckInDate && searchCheckOutDate" class="text-13 text-light-1 mt-2">
                      {{ searchCheckInDate | date:'dd MMM' }} - {{ searchCheckOutDate | date:'dd MMM' }}
                    </div>
                  </div>
                  <button class="button -md -dark-1 bg-blue-1 text-white"
                    [disabled]="isRoomBookingLoading(data.roomGroups[matchedGroupIndex].key)"
                    (click)="goToPassengerInfo(data.roomGroups[matchedGroupIndex].rooms[0]?.key, data.roomGroups[matchedGroupIndex].key)" type="button">
                    <span *ngIf="!isRoomBookingLoading(data.roomGroups[matchedGroupIndex].key)" class="d-flex items-center">
                      Rezervasyon Yap
                      <i class="icon-arrow-top-right ml-10"></i>
                    </span>
                    <span *ngIf="isRoomBookingLoading(data.roomGroups[matchedGroupIndex].key)" class="d-flex items-center">
                      <div class="spinner-border spinner-border-sm mr-10" role="status"></div>
                      Doğrulanıyor...
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <!-- Uyumsuz seçim uyarısı -->
            <div *ngIf="matchedGroupIndex === -1 && (selectedRoomByPosition[0] && selectedRoomByPosition[1])"
                 class="mt-20" style="padding: 12px 16px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px;">
              <span class="text-14 text-dark-1">Bu oda kombinasyonu mevcut değil. Lütfen farklı bir seçim yapın.</span>
            </div>
          </ng-container>

          <!-- ====== TEK ODA TEMPLATE ====== -->
          <ng-template #singleRoomCard let-room let-roomGroup="roomGroup">
            <!-- ====== MOBİL ODA KARTI ====== -->
            <div class="m-room-card" *ngIf="isMobileView">
              <div class="m-room-card__img" *ngIf="room.roomImages?.length"
                   (click)="openRoomInspect(room)"
                   (touchstart)="onMRoomTouchStart($event, room)"
                   (touchend)="onMRoomTouchEnd($event, room)">
                <img [src]="room.roomImages[room._mobileImgIdx || 0]?.url" [alt]="room.roomTypeText || 'Oda'" />
                <div class="m-room-card__dots" *ngIf="room.roomImages.length > 1">
                  <span *ngFor="let _ of room.roomImages.slice(0, 5); let di = index" class="m-room-card__dot" [class.active]="di === (room._mobileImgIdx || 0)"></span>
                </div>
              </div>
              <div class="m-room-card__body">
                <h3 class="m-room-card__name">{{ room.roomTypeText || room.roomType || 'Oda' }}</h3>
                <div class="m-room-card__meal" *ngIf="room.mealType">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8h1a4 4 0 0 1 0 8h-1"/><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"/></svg>
                  {{ room.mealType }}
                </div>
                <button type="button" class="room-inspect-btn" (click)="openRoomInspect(room)">
                  Odayı İncele
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
                </button>
                <div class="m-room-card__price" *ngIf="!isDatelessSearch">
                  <div class="m-room-card__price-info">
                    <span class="m-room-card__nights">{{ getNightCount() > 0 ? getNightCount() : 1 }} Gece</span>
                    <span class="m-room-card__amount" *ngIf="room.totalPrice?.value">
                      {{ room.totalPrice.value | currency : 'TRY' : 'symbol' : '1.0-0' }}
                    </span>
                  </div>
                  <app-installment-badge *ngIf="room.totalPrice?.value" [price]="room.totalPrice.value" [maxInstallment]="maxInstallment" class="d-block"></app-installment-badge>
                </div>
                <div class="m-room-card__actions">
                  <ng-container *ngIf="!isDatelessSearch">
                    <button class="m-room-card__cta"
                            *ngIf="room.availability?.hasAvailability && !room.availability?.minNightRestriction"
                            [disabled]="isRoomBookingLoading(room.key)"
                            (click)="goToPassengerInfo(room.key, roomGroup.key)">
                      Rezervasyon Yap
                    </button>
                    <button class="m-room-card__cta m-room-card__cta--disabled"
                            *ngIf="!room.availability || (!room.availability?.hasAvailability && !room.availability?.minNightRestriction)"
                            disabled>
                      Müsaitlik Bekleniyor...
                    </button>
                  </ng-container>
                  <button class="m-room-card__cta m-room-card__cta--date"
                          *ngIf="isDatelessSearch"
                          (click)="openDatePicker()">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                    Tarih Seç
                  </button>
                </div>
              </div>
            </div>

            <!-- ====== DESKTOP ODA KARTI ====== -->
            <div class="row x-gap-20 y-gap-20" *ngIf="!isMobileView">
              <div class="col-md-auto">
                <div class="cardImage ratio ratio-1:1 w-250 md:w-1/1 rounded-4"
                  [class.cursor-pointer]="room.roomImages && room.roomImages.length > 0"
                  (click)="room.roomImages && room.roomImages.length > 0 && openRoomGalleryModal(room.roomImages, 0)">
                  <div class="cardImage__content">
                    <img *ngIf="room.roomImages && room.roomImages.length > 0"
                      class="rounded-4 col-12"
                      [src]="room.roomImages[0].url"
                      [alt]="room.roomTypeText || room.roomType || 'Oda'" />
                    <div *ngIf="!room.roomImages || room.roomImages.length === 0"
                      class="rounded-4 col-12 bg-light-2 d-flex items-center justify-center" style="height: 100%;">
                      <i class="icon-bed text-40 text-light-1"></i>
                    </div>
                  </div>
                  <div *ngIf="room.roomImages && room.roomImages.length > 1"
                    class="absolute px-10 py-10" style="bottom: 0; right: 0;">
                    <div class="button -blue-1 px-15 py-5 bg-white text-dark-1 text-12 rounded-4">
                      <i class="icon-image mr-5"></i>{{ room.roomImages.length }} Görsel
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md">
                <h3 class="text-18 lh-16 fw-500">
                  {{ room.roomTypeText || room.roomType || 'Oda' }}
                </h3>

                <div class="row x-gap-10 y-gap-10 items-center pt-10">
                  <div class="col-auto">
                    <a class="text-14 text-blue-1 fw-500 cursor-pointer">
                      {{ room.mealType || 'Konaklama' }}
                      <i class="icon-chevron-right text-10 ml-5"></i>
                    </a>
                  </div>
                </div>

                <div *ngIf="hasMinNightRestriction || room.availability?.minNightRestriction" class="text-14 text-light-1 mt-5">
                  Minimum {{ room.availability?.minNight || minNightCount }} Gece Konaklama
                </div>

                <div class="text-14 lh-15 mt-10">
                  <div *ngIf="!room.isNonCancellable" class="d-flex items-center">
                    <span class="text-dark-1">• İptal Politikası</span>
                    <i class="icon-info text-12 ml-5 text-light-1 cursor-pointer"></i>
                  </div>
                </div>

                <div *ngIf="hasMinNightRestriction || room.availability?.minNightRestriction" class="mt-15">
                  <span class="text-14" style="color: #e67e22;">
                    Seçilen tarihte en az {{ room.availability?.minNight || minNightCount }} gece ve üzeri konaklayabilirsiniz.
                  </span>
                </div>

                <div class="row x-gap-10 y-gap-10 pt-15">
                  <div class="col-auto" *ngFor="let facility of getRoomFacilitiesToShow(room)">
                    <div class="border-light rounded-100 py-5 px-20 text-14 lh-14">
                      {{ facility.name }}
                    </div>
                  </div>
                </div>

                <div *ngIf="room.facilities && room.facilities.length > 6" class="mt-10">
                  <a (click)="toggleRoomFacilities(room.key || room.roomKey || room.hotelRoomCode)"
                    class="text-blue-1 fw-500 cursor-pointer text-14">
                    {{ showAllRoomFacilities[room.key || room.roomKey || room.hotelRoomCode] ? "Daha Az Göster" : "Tümünü Gör" }}
                  </a>
                </div>
              </div>

              <div class="col-md-auto text-right md:text-left">
                <div class="text-14 text-dark-1 fw-500" *ngIf="searchCheckInDate && searchCheckOutDate">
                  {{ searchCheckInDate | date:'dd.MM.yyyy' }} - {{ searchCheckOutDate | date:'dd.MM.yyyy' }}
                </div>

                <!-- ====== TARİHSİZ ARAMA MODU ====== -->
                <ng-container *ngIf="isDatelessSearch">
                  <div class="mt-5">
                    <div class="text-13 text-light-1">
                      Fiyatı görmek için tarih seçiniz
                    </div>
                  </div>
                  <div class="mt-10">
                    <button class="detail-date-btn"
                      (click)="scrollToDateSelection(); $event.stopPropagation()" type="button">
                      Tarih Seçin
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                    </button>
                  </div>
                </ng-container>

                <!-- ====== TARİHLİ ARAMA MODU ====== -->
                <ng-container *ngIf="!isDatelessSearch">
                <div *ngIf="room.discount && room.discount.value > 0" class="mt-5">
                  <div class="text-14 text-light-1" style="text-decoration: line-through;">
                    {{ (room.totalPrice.value + room.discount.value) | currency : "TRY" : "symbol" : "1.0-0" }}
                  </div>
                  <div class="text-22 lh-12 fw-600">
                    {{ room.totalPrice.value | currency : "TRY" : "symbol" : "1.0-0" }}
                  </div>
                  <div class="text-12 text-green-2 fw-500">
                    {{ room.discount.value | currency : "TRY" : "symbol" : "1.0-0" }} indirim
                  </div>
                  <app-installment-badge [price]="room.totalPrice.value" [maxInstallment]="maxInstallment" class="d-block mt-5"></app-installment-badge>
                </div>

                <div *ngIf="!room.discount || room.discount.value === 0" class="mt-5">
                  <div class="text-22 lh-12 fw-600">
                    <span *ngIf="room.totalPrice && room.totalPrice.value">
                      {{ room.totalPrice.value | currency : "TRY" : "symbol" : "1.0-0" }}
                    </span>
                    <span *ngIf="(!room.totalPrice || !room.totalPrice.value) && room.availability?.minNightRestriction" class="text-14" style="color: #ffc107;">
                      <i class="icon-calendar mr-5"></i>
                      Min {{ room.availability?.minNight || minNightCount }} gece için fiyat alın
                    </span>
                    <span *ngIf="(!room.totalPrice || !room.totalPrice.value) && !room.availability?.minNightRestriction" class="text-light-1 text-16">
                      Fiyat bilgisi yok
                    </span>
                  </div>
                  <div *ngIf="room.totalPrice && room.totalPrice.value" class="text-14 text-light-1">Oda Fiyatı</div>
                  <app-installment-badge *ngIf="room.totalPrice?.value" [price]="room.totalPrice.value" [maxInstallment]="maxInstallment" class="d-block mt-5"></app-installment-badge>
                </div>

                <div *ngIf="room.availability" class="mt-10">
                  <div *ngIf="room.availability.hasAvailability && !room.availability.minNightRestriction" class="d-flex items-center justify-end md:justify-start text-green-2">
                    <i class="icon-check text-12 mr-5"></i>
                    <span class="text-14 fw-500">Müsait</span>
                  </div>
                  <div *ngIf="room.availability.minNightRestriction" class="d-flex items-center justify-end md:justify-start" style="color: #ffc107;">
                    <i class="icon-calendar text-12 mr-5"></i>
                    <span class="text-14 fw-500">Min {{ room.availability?.minNight || minNightCount }} Gece</span>
                  </div>
                  <div *ngIf="!room.availability.hasAvailability && !room.availability.minNightRestriction" class="d-flex items-center justify-end md:justify-start text-red-2">
                    <i class="icon-close text-12 mr-5"></i>
                    <span class="text-14 fw-500">Müsait Değil</span>
                  </div>
                </div>

                <div *ngIf="room.availability?.hasAvailability === true && !room.availability?.minNightRestriction" class="mt-20">
                  <button class="button -md -dark-1 bg-blue-1 text-white"
                    [disabled]="isRoomBookingLoading(room.key)"
                    (click)="goToPassengerInfo(room.key, roomGroup.key)" type="button">
                    <span *ngIf="!isRoomBookingLoading(room.key)" class="d-flex items-center justify-center">
                      Rezervasyon Yap
                      <i class="icon-arrow-top-right ml-10"></i>
                    </span>
                    <span *ngIf="isRoomBookingLoading(room.key)" class="d-flex items-center">
                      <div class="spinner-border spinner-border-sm mr-10" role="status"></div>
                      Doğrulanıyor...
                    </span>
                  </button>
                </div>

                <div *ngIf="room.availability?.minNightRestriction" class="mt-20">
                  <button class="button -md text-white" disabled style="cursor: not-allowed; background-color: #ffc107;">
                    <i class="icon-calendar mr-10"></i>
                    Min {{ room.availability?.minNight || minNightCount }} Gece
                  </button>
                  <div class="text-12 text-light-1 mt-5">
                    Bu oda için minimum {{ room.availability?.minNight || minNightCount }} gece konaklama gereklidir
                  </div>
                </div>

                <!-- Availability yükleniyor -->
                <div *ngIf="!room.availability && !room.availability?.minNightRestriction" class="mt-20">
                  <button class="button -md -outline-dark-1 text-light-1" disabled style="cursor: wait;">
                    <div class="spinner-border spinner-border-sm mr-10" role="status"></div>
                    Müsaitlik kontrol ediliyor...
                  </button>
                </div>

                <!-- Müsait değil (availability yüklendi ve false) -->
                <div *ngIf="room.availability && room.availability.hasAvailability === false && !room.availability.minNightRestriction" class="mt-20">
                  <button class="button -md -outline-dark-1 text-dark-1" disabled style="cursor: not-allowed;">
                    <span *ngIf="room.availability?.statusSummary?.noQuota > 0; else defaultUnavailable">Kontenjan Yok</span>
                    <ng-template #defaultUnavailable>Müsait Değil</ng-template>
                  </button>
                </div>
                </ng-container>

                <div *ngIf="getRoomBookingError(room.key)" class="mt-10 text-14 text-red-2">
                  {{ getRoomBookingError(room.key) }}
                  <a (click)="clearRoomBookingError(room.key)" class="text-blue-1 ml-10 cursor-pointer">Kapat</a>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </section>
    </main>
  </div>
</div>

<!-- Fullscreen Calendar Modal -->
<div class="fs-cal" *ngIf="isFullscreenCalendarOpen">
  <div class="fs-cal__header">
    <button type="button" class="fs-cal__close" (click)="closeFullscreenCalendar()" aria-label="Kapat">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    </button>
    <div class="fs-cal__title">Tarih Seçin</div>
    <button type="button" class="fs-cal__clear"
            (click)="minNightCheckInDate = null; minNightCheckOutDate = null; inlineCalendarSelectionStart = null; inlineCalendarSelectionEnd = null; generateInlineCalendarDays()">
      Temizle
    </button>
  </div>

  <div class="fs-cal-selected">
    <div class="fs-cal-selected__item">
      <div class="fs-cal-selected__label">GİRİŞ</div>
      <div class="fs-cal-selected__date">{{ minNightCheckInDate ? (minNightCheckInDate | date:'dd MMM yyyy':'':'tr') : '-' }}</div>
    </div>
    <div class="fs-cal-selected__divider"></div>
    <div class="fs-cal-selected__item">
      <div class="fs-cal-selected__label">ÇIKIŞ</div>
      <div class="fs-cal-selected__date">{{ minNightCheckOutDate ? (minNightCheckOutDate | date:'dd MMM yyyy':'':'tr') : '-' }}</div>
    </div>
  </div>

  <div class="fs-cal-body">
    <div class="fs-cal-nav">
      <button type="button" (click)="prevCalendarMonth()" class="fs-cal-nav__btn">‹</button>
      <strong class="fs-cal-nav__month">{{ getCalendarMonthYear() }}</strong>
      <button type="button" (click)="nextCalendarMonth()" class="fs-cal-nav__btn">›</button>
    </div>

    <div class="fs-cal-weekdays">
      <span *ngFor="let d of ['Pt','Sl','Çr','Pr','Cm','Ct','Pz']">{{ d }}</span>
    </div>

    <div class="fs-cal-grid">
      <button *ngFor="let day of inlineCalendarDays"
              type="button"
              [disabled]="day.isPast"
              (click)="selectCalendarDate(day)"
              class="fs-cal-day"
              [class.is-other]="!day.isCurrentMonth"
              [class.is-disabled]="day.isPast"
              [class.is-selected]="day.isSelected || day.isStart || day.isEnd"
              [class.is-range]="day.isInRange">
        {{ day.dayNumber }}
      </button>
    </div>
  </div>

  <div class="fs-cal__footer">
    <button type="button" class="fs-cal__cta"
            [disabled]="!minNightCheckInDate || !minNightCheckOutDate"
            (click)="confirmCalendarDates()">
      {{ minNightCheckInDate && minNightCheckOutDate ? (getNightCount() + ' Gece — Ara') : 'Tarihleri Seçin' }}
    </button>
  </div>
</div>

<!-- Fullscreen Room Inspect Modal -->
<div class="fs-cal" *ngIf="inspectRoom">
  <div class="fs-cal__header">
    <button type="button" class="fs-cal__close" (click)="inspectRoom = null; onModalClose()" aria-label="Geri">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
    </button>
    <div class="fs-cal__title">{{ inspectRoom.roomTypeText || inspectRoom.roomType || 'Oda' }}</div>
    <div style="width: 36px;"></div>
  </div>

  <div class="room-inspect-body">
    <div class="room-inspect__gallery" *ngIf="inspectRoom.roomImages?.length"
         (touchstart)="onRoomInspectTouchStart($event)"
         (touchend)="onRoomInspectTouchEnd($event)">
      <img [src]="inspectRoom.roomImages[inspectRoomImgIdx]?.url" [alt]="inspectRoom.roomTypeText" />
      <div class="room-inspect__gallery-dots" *ngIf="inspectRoom.roomImages.length > 1">
        <span *ngFor="let img of inspectRoom.roomImages; let di = index"
              class="room-inspect__dot"
              [class.active]="di === inspectRoomImgIdx"
              (click)="inspectRoomImgIdx = di"></span>
      </div>
    </div>

    <div class="room-inspect__content">
      <h2 class="room-inspect__name">{{ inspectRoom.roomTypeText || inspectRoom.roomType || 'Oda' }}</h2>

      <div class="room-inspect__meta">
        <span *ngIf="inspectRoom.maxAdult || inspectRoom.maxPax">{{ inspectRoom.maxAdult || inspectRoom.maxPax }} Yetişkin</span>
        <span *ngIf="inspectRoom.roomSize">• {{ inspectRoom.roomSize }} m²</span>
      </div>

      <div class="room-inspect__meal" *ngIf="inspectRoom.mealType">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3554d1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8h1a4 4 0 0 1 0 8h-1"/><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"/><line x1="6" y1="1" x2="6" y2="4"/><line x1="10" y1="1" x2="10" y2="4"/><line x1="14" y1="1" x2="14" y2="4"/></svg>
        {{ inspectRoom.mealType }}
      </div>

      <p class="room-inspect__desc" *ngIf="inspectRoom.description" [innerHTML]="inspectRoom.description"></p>

      <div class="room-inspect__facilities" *ngIf="inspectRoom.facilities?.length">
        <div class="room-inspect__facility" *ngFor="let f of inspectRoom.facilities">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3554d1" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
          <span>{{ f.name }}</span>
          <span class="room-inspect__paid" *ngIf="f.paidTypeValue > 0"></span>
        </div>
      </div>

      <p class="room-inspect__paid-note" *ngIf="inspectRoom.facilities?.length"></p>

      <div class="room-inspect__price-section" *ngIf="inspectRoom.totalPrice?.value && !isDatelessSearch">
        <div class="room-inspect__price-top">
          <span class="room-inspect__price-nights">{{ getNightCount() > 0 ? getNightCount() : 1 }} Gece</span>
          <span class="room-inspect__price-amount">{{ inspectRoom.totalPrice.value | currency : 'TRY' : 'symbol' : '1.0-0' }}</span>
        </div>
        <div class="room-inspect__price-bottom">
          <app-installment-badge [price]="inspectRoom.totalPrice.value" [maxInstallment]="maxInstallment"></app-installment-badge>
        </div>
      </div>

      <button type="button" class="room-inspect__back-btn" (click)="inspectRoom = null; onModalClose()">
        Diğer Odaları İncele
      </button>
    </div>
  </div>
</div>

<!-- Konum Modal -->
<div class="konum-modal" *ngIf="konumModal">
  <div class="konum-modal__header">
    <button type="button" class="konum-modal__back" (click)="closeKonumModal()" aria-label="Geri">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
    </button>
    <div class="konum-modal__title">Konum</div>
    <div style="width: 36px;"></div>
  </div>

  <div class="konum-modal__body">
    <div class="konum-modal__map">
      <iframe *ngIf="konumModal.mapUrl"
              [src]="konumModal.mapUrl"
              width="100%" height="100%" frameborder="0"
              style="border:0" allowfullscreen
              referrerpolicy="no-referrer-when-downgrade"></iframe>
      <div class="konum-modal__pin" *ngIf="konumModal.mapUrl" aria-hidden="true">
        <svg width="44" height="44" viewBox="0 0 24 24" fill="#3554d1" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3" fill="#fff" stroke="#3554d1"/></svg>
      </div>
      <div class="konum-modal__map-fallback" *ngIf="!konumModal.mapUrl">
        <i class="icon-location text-40 text-light-1"></i>
        <span class="text-14 text-light-1 mt-10">Harita bilgisi bulunamadı</span>
      </div>
    </div>

    <div class="konum-modal__sheet" *ngIf="konumModal.hotelName || konumModal.nearDistances?.length">
      <div class="konum-modal__sheet-handle"></div>
      <div class="konum-modal__sheet-body">
        <div class="konum-hotel-card">
          <div class="konum-hotel-card__image" *ngIf="konumModal.hotelImage">
            <img [src]="konumModal.hotelImage" [alt]="konumModal.hotelName" />
          </div>
          <div class="konum-hotel-card__info">
            <div class="konum-hotel-card__name">{{ konumModal.hotelName }}</div>
            <div class="konum-hotel-card__distances" *ngIf="konumModal.nearDistances?.length">
              <div class="konum-hotel-card__dist" *ngFor="let d of konumModal.nearDistances.slice(0, 4)">
                <span class="konum-hotel-card__dist-icon">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                </span>
                <span class="konum-hotel-card__dist-name">{{ d.name }}</span>
                <strong class="konum-hotel-card__dist-value">{{ d.distance }} {{ d.unitTypeText }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Facilities Bottom Sheet -->
<div class="fac-sheet-backdrop" *ngIf="facilitiesSheet" (click)="closeFacilitiesSheet()"></div>
<div class="fac-sheet" *ngIf="facilitiesSheet">
  <div class="fac-sheet__handle" (click)="closeFacilitiesSheet()"></div>
  <div class="fac-sheet__header">
    <div>
      <div class="fac-sheet__title">{{ facilitiesSheet.title }}</div>
      <div class="fac-sheet__subtitle">{{ getFacilitiesTotal() }} özellik</div>
    </div>
    <button type="button" class="fac-sheet__close" (click)="closeFacilitiesSheet()" aria-label="Kapat">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    </button>
  </div>

  <div class="fac-sheet__tabs" *ngIf="facilitiesSheet.groups.length > 1">
    <button type="button"
            *ngFor="let g of facilitiesSheet.groups; let i = index"
            class="fac-sheet__tab"
            [class.active]="activeFacilityGroup === i"
            (click)="setFacilityGroup(i)">
      {{ g.name }}
    </button>
  </div>

  <div class="fac-sheet__body">
    <div class="fac-sheet__item" *ngFor="let f of facilitiesSheet.groups[activeFacilityGroup]?.items">
      <span class="fac-sheet__check">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
      </span>
      {{ f.name }}
    </div>
  </div>
</div>

<ng-template #loading>
  <div *ngIf="hotelPreview; else fullLoader">
    <main>
      <section class="pt-40">
        <div class="container">
          <div class="hotelSingleGrid">
            <div>
              <!-- Desktop Gallery Skeleton -->
              <div class="galleryGrid -type-2 d-none d-md-grid" *ngIf="hotelPreview.image">
                <div class="galleryGrid__item relative d-flex justify-end">
                  <img [src]="hotelPreview.image" [alt]="hotelPreview.name" class="rounded-4" />
                </div>
                <div class="galleryGrid__item"><div class="skeleton-pulse rounded-4 h-full"></div></div>
                <div class="galleryGrid__item"><div class="skeleton-pulse rounded-4 h-full"></div></div>
                <div class="galleryGrid__item"><div class="skeleton-pulse rounded-4 h-full"></div></div>
              </div>

              <!-- Mobile Gallery Skeleton -->
              <div class="mobile-gallery-slider d-md-none" *ngIf="hotelPreview.image">
                <div class="mobile-gallery-container">
                  <img [src]="hotelPreview.image" [alt]="hotelPreview.name" class="mobile-gallery-image rounded-4" />
                </div>
              </div>

              <!-- Mobile Hero Skeleton -->
              <div class="mobile-hotel-hero d-md-none">
                <h1 class="mobile-hotel-hero__name">{{ hotelPreview.name }}</h1>
                <div class="mobile-hotel-hero__location" *ngIf="hotelPreview.location">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                  <span>{{ hotelPreview.location }}</span>
                </div>
              </div>

              <!-- Desktop Otel Adı -->
              <div class="row justify-between items-end pt-40 d-none d-md-flex">
                <div class="col-auto">
                  <h1 class="text-30 fw-600">{{ hotelPreview.name }}</h1>
                  <div *ngIf="hotelPreview.location" class="hotel-location-btn" style="cursor: default; margin-top: 8px;">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                    <span>{{ hotelPreview.location }}</span>
                  </div>
                </div>
              </div>

              <!-- Otel Özellikleri Skeleton -->
              <div class="hotel-facility-chips" style="margin-top: 20px;">
                <div class="skeleton-pulse" *ngFor="let i of [1,2,3,4]" [style.width]="(80 + i * 20) + 'px'" style="height: 34px; border-radius: 8px;"></div>
              </div>
              <div class="skeleton-pulse" style="width: 220px; height: 40px; border-radius: 999px; margin-top: 16px;"></div>
            </div>

            <!-- Sağ sidebar (sadece desktop) -->
            <div class="hide-on-mobile">
              <div class="px-30 py-30 border-light rounded-4">
                <div class="skeleton-pulse rounded-4" style="width: 100%; height: 200px;"></div>
                <div class="border-top-light mt-15 mb-15"></div>
                <div class="skeleton-pulse rounded-4" style="width: 60%; height: 16px;"></div>
                <div *ngFor="let i of [1,2,3]" class="d-flex justify-between pt-10">
                  <div class="skeleton-pulse rounded-4" style="width: 20px; height: 20px;"></div>
                  <div class="skeleton-pulse rounded-4" style="width: 40%; height: 14px;"></div>
                  <div class="skeleton-pulse rounded-4" style="width: 25%; height: 14px;"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- Oda Kartları Skeleton -->
          <h3 class="text-22 fw-500 pt-30">Odalar</h3>

          <!-- Mobile Oda Skeleton -->
          <div *ngIf="isMobileView">
            <div *ngFor="let i of [1, 2, 3]" class="m-room-card" style="margin-top: 16px;">
              <div class="skeleton-pulse" style="width: 100%; aspect-ratio: 16/10;"></div>
              <div style="padding: 14px 16px;">
                <div class="skeleton-pulse rounded-4" style="width: 70%; height: 18px;"></div>
                <div class="skeleton-pulse rounded-4" style="width: 40%; height: 14px; margin-top: 8px;"></div>
                <div class="skeleton-pulse rounded-4" style="width: 30%; height: 14px; margin-top: 8px;"></div>
                <div class="skeleton-pulse rounded-4" style="width: 50%; height: 22px; margin-top: 12px; margin-left: auto;"></div>
                <div class="skeleton-pulse" style="width: 100%; height: 46px; border-radius: 12px; margin-top: 12px;"></div>
              </div>
            </div>
          </div>

          <!-- Desktop Oda Skeleton -->
          <div *ngIf="!isMobileView">
            <div *ngFor="let i of [1, 2, 3]" class="border-top-light pt-30 mt-30">
              <div class="row x-gap-20 y-gap-20">
                <div class="col-md-auto">
                  <div class="skeleton-pulse rounded-4" style="width: 250px; height: 250px;"></div>
                </div>
                <div class="col-md">
                  <div class="skeleton-pulse rounded-4" style="width: 60%; height: 20px;"></div>
                  <div class="skeleton-pulse rounded-4" style="width: 35%; height: 16px; margin-top: 10px;"></div>
                  <div class="skeleton-pulse rounded-4" style="width: 45%; height: 14px; margin-top: 10px;"></div>
                  <div class="d-flex" style="gap: 8px; margin-top: 15px;">
                    <div class="skeleton-pulse" style="width: 90px; height: 30px; border-radius: 100px;"></div>
                    <div class="skeleton-pulse" style="width: 110px; height: 30px; border-radius: 100px;"></div>
                    <div class="skeleton-pulse" style="width: 75px; height: 30px; border-radius: 100px;"></div>
                  </div>
                </div>
                <div class="col-md-auto text-right">
                  <div class="skeleton-pulse rounded-4" style="width: 100px; height: 28px; margin-left: auto;"></div>
                  <div class="skeleton-pulse rounded-4" style="width: 70px; height: 14px; margin-left: auto; margin-top: 5px;"></div>
                  <div class="skeleton-pulse rounded-4" style="width: 150px; height: 44px; margin-left: auto; margin-top: 20px;"></div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
    </main>
  </div>

  <ng-template #fullLoader>
    <app-loading [size]="'large'" [fullScreen]="true"></app-loading>
  </ng-template>
</ng-template>